import React from 'react';
import {connect} from 'react-redux';
import cn from "classnames";
import PropTypes from 'prop-types';
import Page from '../../components/page/page';
import Footer from '../../components/footer/footer.jsx';

import {getClazzes} from '../../api/clazz';

import styles from "../../lib/global.css";
import {setClazzes} from "../../reducers/teach";
import bindAll from "lodash.bindall";
import LibraryComponent from "../../../components/library/library-no-modal";
import TeacherNavBar from "../../components/teacher-nav-bar/teacher-nav-bar";
import ClazzList from "../../components/clazz-list/clazz-list";
import TeacherCoursePage from "../teacher-course/teacher-course";
import PageContentMargin from "../../components/page-content-margin/page-content-margin";
import ButtonComponent from "../../../components/button/button";
import BannerInfo from "../../components/banner-info/banner-info";
import ModalManager from "../../components/modal/modal-manager";
import ClazzFormModal from "../../components/clazz-form-modal/clazz-form-modal";

/**
 * 班级列表页
 */
class  TeacherClazzesPage extends React.PureComponent{
    constructor(props) {
        super(props);
        bindAll(this, [
            'getClazzes',
            'openCreateClazzModal'
        ]);
    }

    componentDidMount() {
        this.getClazzes();
    }

    getClazzes() {
        getClazzes({page_size:100}, {quiet: this.props.clazzes.data.length > 0}).then(res => {
            this.props.setClazzes(res);
        });
    }

    openCreateClazzModal() {
        ModalManager.open(ClazzFormModal, {
            onClose: ()=>{},
            onSubmit: ()=>{this.getClazzes()}
        })
    }


    render() {
        return (
            <Page isModal={true} title={window.L('teach.classes.manage')}>
                <PageContentMargin>
                    <BannerInfo
                        title="班级管理"
                        cover={`${window.config.staticURL}/cover/class/default.png`}
                        desc={window.L("teach.class.listPageDesc")}
                        buttons={
                            <ButtonComponent
                                className={styles.button}
                                onClick={() => this.openCreateClazzModal()}
                            >创建班级</ButtonComponent>
                        }
                    />
                    <ClazzList items={this.props.clazzes.data}/>

                </PageContentMargin>
                <Footer/>
            </Page>
        );
    }
}

TeacherClazzesPage.propTypes = {
    clazzes: PropTypes.object,
    setClazzes: PropTypes.func,
}

const mapStateToProps = state => ({
    clazzes: state.teach.clazzes,
});


const mapDispatchToProps = dispatch => ({
    setClazzes: clazzes => dispatch(setClazzes(clazzes))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TeacherClazzesPage);
